// @ts-nocheck
import { skipNavStyles } from "@insite/content-library/Components/SkipNav";
import { css } from "styled-components";

Object.assign(skipNavStyles, {
    skipToContent: {
        variant: "primary",
        css: css`
            ${x => x.theme.button.primary.css}
            ${skipNavStyles.skipToContent?.css}
        `,
    },
});
